<template>
  <div class="login-container">
    <div class="login-card">
      <h2 class="login-title">{{ t('login.title') }}</h2>
      <p class="login-subtitle">{{ t('login.subtitle') }}</p>

      <button @click="handleLogin" class="login-button" :disabled="isLoading">
        <span v-if="!isLoading">{{ t('login.button') }}</span>
        <span v-else>{{ t('login.loading') }}</span>
      </button>

      <p class="login-note">
        <small>{{ t('login.note') }}</small>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAuth } from '@/composables/useAuth';

const { t } = useI18n();
const { loginWithOAuth2 } = useAuth();

const isLoading = ref(false);

const handleLogin = async () => {
  try {
    isLoading.value = true;

    // APP 專用：使用 OAuth2 流程
    await loginWithOAuth2();
  } catch (error) {
    console.error('登入失敗:', error);
    alert(t('login.failed'));
  } finally {
    isLoading.value = false;
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-card {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 100%;
  text-align: center;
}

.login-title {
  color: #333;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
}

.login-subtitle {
  color: #666;
  font-size: 14px;
  margin-bottom: 32px;
}

.login-button {
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.login-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

.login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-note {
  margin-top: 24px;
  color: #999;
}

.login-note small {
  font-size: 12px;
}
</style>
